import React from 'react';

// `tags` is server rendered markup (see RenderKunstOrteTags.ss)
const GridItem = ({ href, image, topline, headline, subline, tags }) => (
    <a className="griditem" href={href}>
        {image
            ? <img src={image}/>
            : <div className="griditem_dummy"></div>
        }
        <div className="griditem_content_text">
            <h2 class="hl3">{ headline }</h2>
            <p className="topline">{ topline }</p>
            { subline ? <p className="subline">{ subline }</p> : null }
            { tags ? <div dangerouslySetInnerHTML={{__html: tags}}/> : null }
        </div>
    </a>
);

export default GridItem;
